import React, { useState, useEffect, useCallback } from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import {
    CircularProgressbar,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
// Crop imports
import CropModal from '../../../utils/ImageCropModal';
import getCroppedImg from '../../../utils/cropImage';

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../../../utils/AnimatedProgressProvider";

import { Link, useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PhoneInput, { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input'

import 'react-international-phone/style.css';
import { useDispatch, useSelector } from 'react-redux'
import { getCityData, getCountryData, getProfileData, getStateData } from '../../../Redux/action/MasterAction';
import Beatloader from '../../../Common/BeatLoader';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import HourglassLoader from '../../../Common/HourglassLoader';

const host = process.env.REACT_APP_API_SERVER
const StudentProfileUpdate = () => {

    const [phone, setPhone] = useState('');
    const [caltphone, setcaltPhone] = useState('');
    // Remove non-digit characters
    const cleanPhoneNumber = phone.replace(/\D/g, '');

    // Check if there are digits after the fourth digit
    const hasDigitsAfterFourth = cleanPhoneNumber.length > 8;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [filePreview, setFilePreview] = useState(null);
    const authToken = localStorage.getItem('student-token');


    // Crop states
    const [isCropModalOpen, setIsCropModalOpen] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [originalFile, setOriginalFile] = useState(null);

    useEffect(() => {
        dispatch(getProfileData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,

        //country
        loadingCountryDataListApi,
        CountryDataListApiData,
        CountryDataListApiError,

        //state
        loadingStateDataListApi,
        StateDataListApiData,
        StateDataListApiError,

        //city
        loadingCityDataListApi,
        CityDataListApiData,
        CityDataListApiError,
    } = useSelector(state => state?.MasterReducer);


    useEffect(() => {

        dispatch(getCountryData());
    }, []);







    let [initialValues, setInitialValues] = useState({

        name: "",
        lastName: "",
        country_code: "",
        mobile: "",
        email: "",
        dob: "",
        gender: "",
        password: "",
        cpassword: "",
        about_the_tutor: "",
        country_id: "",
        state_id: "",
        city_id: "",
        address_line_1: "",
        address_line_2: "",
        zip_code: "",
        user_type: "",
        profile_image: "",



    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            name: Yup.string().required("Name is required").matches(/^[a-zA-Z .]+$/, "Name can only contain letters."),
            // email: Yup.string().required("Email is required.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/, "Enter a valid E-mail"),
            // mobile: Yup.string().required("Phone is required").matches(/^[0-9]{8,15}$/, "Please enter a valid Mobile Number."),
            country_id: Yup.string().required("Country is required"),
            gender: Yup.string().required("Gender is required"),

            country_id: Yup.string().required("Country is required"),
            state_id: Yup.string().required("State is required"),
            city_id: Yup.string().required("City is required"),
            address_line_1: Yup.string().required("Address line 1 is required"),
            zip_code: Yup.string().required("Zip code is required").matches(/^[0-9]+$/, "Please enter a valid Zip Code."),



        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {

            try {

                setSubmitting(true);
                let config = {
                    headers: {

                        'Content-Type': 'multipart/form-data',
                        "x-auth-token": localStorage.getItem('student-token'),
                    },
                };
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("email", values.email)
                formData.append("country_code", values.country_code)
                formData.append("mobile", values.mobile)
                formData.append("dob", values.dob)
                formData.append("gender", values.gender)
                formData.append("country_id", values.country_id)
                formData.append("state_id", values.state_id)
                formData.append("city_id", values.city_id)
                formData.append("address_line_1", values.address_line_1)
                formData.append("address_line_2", values.address_line_2)
                formData.append("zip_code", values.zip_code)
                formData.append("user_type", values.user_type)
                formData.append("profile_image", values.profile_image)



                axios.post(`${host}/api/auth/user-profile-update`, formData, config)

                    .then(res => {

                        if (res.status == 200) {

                            toast.success(res.data.message);
                            setSubmitting(false);
                            setFilePreview(null);
                            dispatch(getProfileData(authToken))

                        } else {

                            toast.error(res.data.message);
                            setSubmitting(false);
                        }
                    }).catch(err => {
                        console.log('error', err)
                        toast.error(err.response.data.error[0].message);
                        setSubmitting(false);
                    });

            }
            catch (error) {

                // console.log(error);
                toast.error(error.response.data.message);
                setSubmitting(false);

            }

        }
    });


    useEffect(() => {

        if (ProfileDataListApiData?.data) {
            formik.setValues({
                name: ProfileDataListApiData?.data?.name ?? "",
                email: ProfileDataListApiData?.data?.email ?? "",
                country_code: ProfileDataListApiData?.data?.country_code ?? "",
                mobile: ProfileDataListApiData?.data?.mobile ?? "",
                dob: ProfileDataListApiData?.data?.dob ?? "",
                gender: ProfileDataListApiData?.data?.gender ?? "",
                country_id: ProfileDataListApiData?.data?.country_id ?? "",
                state_id: ProfileDataListApiData?.data?.state_id ?? "",
                city_id: ProfileDataListApiData?.data?.city_id ?? "",
                address_line_1: ProfileDataListApiData?.data?.address_line_1 ?? "",
                address_line_2: ProfileDataListApiData?.data?.address_line_2 ?? "",
                zip_code: ProfileDataListApiData?.data?.zip_code ?? "",
                profile_image: ProfileDataListApiData?.data?.profile_img ?? "",
                user_type: ProfileDataListApiData?.data?.user_type ?? "",

            })
            // setPhone(ProfileDataListApiData?.data?.mobile)
        }
    }, [ProfileDataListApiData?.data])
    useEffect(() => {
        dispatch(getStateData(formik.values.country_id))
    }, [formik.values.country_id])

    useEffect(() => {
        dispatch(getCityData(formik.values.state_id))
    }, [formik.values.state_id])

    const handleCountryChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('state_id', '')
        formik.setFieldValue('city_id', '')

        if (id == '') {
            dispatch(getStateData('0'))
        }
        else {
            dispatch(getStateData(id))
        }
        dispatch(getCityData(0))
    }

    const handleStateChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('city_id', '')
        if (id == '') {
            dispatch(getCityData('0'))
        }
        else {
            dispatch(getCityData(id))
        }
    }


    const handleGroupFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {

            setOriginalFile(file);


            const previewUrl = URL.createObjectURL(file);
            setImageToCrop(previewUrl);
            setIsCropModalOpen(true);


            e.target.value = "";
        }
    };


    const handleCropComplete = useCallback(async (croppedBlob, croppedFileUrl) => {
        try {

            const croppedFile = new File([croppedBlob], "profile-image.jpg", {
                type: "image/jpeg"
            });

            formik.setFieldValue('profile_image', croppedFile);


            setFilePreview(croppedFileUrl);


            setIsCropModalOpen(false);
            setImageToCrop(null);

        } catch (error) {
            console.error('Error cropping image:', error);
            toast.error('Failed to crop image');
        }
    }, [formik]);

    // Handle crop cancel
    const handleCropCancel = useCallback(() => {
        setIsCropModalOpen(false);
        setImageToCrop(null);
        setOriginalFile(null);

        if (filePreview && filePreview !== `${host}${ProfileDataListApiData?.data?.profile_img}`) {
            URL.revokeObjectURL(filePreview);
        }
        setFilePreview(null);
    }, [filePreview, ProfileDataListApiData]);

    // const handleGroupFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {

    //         setFilePreview(URL.createObjectURL(file));

    //         formik.setFieldValue('profile_image', file);
    //     }
    // };


    const handlePhoneClick = (value) => {
        try {
            const phoneNumber = parsePhoneNumber(value);
            if (phoneNumber && phoneNumber.isValid()) { // Ensure the parsed number is valid


                formik.setFieldValue('mobile', phoneNumber.nationalNumber);
                formik.setFieldValue('country_code', phoneNumber.countryCallingCode);
            } else {
                console.error("Invalid phone number");
                formik.setFieldValue('mobile', ''); // Clear invalid number
                formik.setFieldValue('country_code', '');
            }
        } catch (error) {
            console.error("Error parsing phone number:", error);
            formik.setFieldValue('mobile', ''); // Handle invalid input gracefully
            formik.setFieldValue('country_code', '');
        }
    };

    // useEffect(() => { console.log(formik) }, [formik])

    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Profile
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="p-0 bg-light">
                                {loadingProfileDataListApi ?
                                    <Beatloader />
                                    :
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="student-profile-sec px-3">
                                            <div className="row mb-5">

                                                <div className="col-lg-12 mb-2 w-100 d-flex justify-content-center pt-5">
                                                    <div className="profile-top-sec w-50">
                                                        <div className="profile-top-img d-flex justify-content-center">
                                                            <OverlayTrigger

                                                                placement='right'
                                                                overlay={
                                                                    <Tooltip className='bg-light'>
                                                                        {ProfileDataListApiData?.profile_status_percentage ?? 0}%
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="img-sec position-relative">
                                                                    {/* Circular Progress Bar */}
                                                                    <AnimatedProgressProvider
                                                                        valueStart={0}
                                                                        valueEnd={ProfileDataListApiData?.profile_status_percentage ?? 0}
                                                                        duration={1.4}
                                                                        easingFunction={easeQuadInOut}

                                                                    >
                                                                        {value => {
                                                                            const roundedValue = Math.round(value);
                                                                            return (
                                                                                <CircularProgressbar
                                                                                    value={value}
                                                                                // text={`${ProfileDataListApiData?.profile_status_percentage}%`}
                                                                                /* This is important to include, because if you're fully managing the
                                                                          animation yourself, you'll want to disable the CSS animation. */
                                                                                // styles={buildStyles({ pathTransition: "none" })}
                                                                                />
                                                                            );
                                                                        }}
                                                                    </AnimatedProgressProvider>
                                                                    {/* Profile Image */}
                                                                    <div className='d-flex justify-content-end w-100 flex-wrap'>
                                                                        {!ProfileDataListApiData?.data?.profile_img && (
                                                                            <img
                                                                                className='upload-image-style'
                                                                                title='Upload Profile Image'
                                                                                width={100}
                                                                                src='/assets/img/user/upload.png'
                                                                                onClick={() => document.getElementById("uploadVideo").click()}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                        )}
                                                                        <input
                                                                            id="uploadVideo"
                                                                            type="file"
                                                                            accept="image/*"
                                                                            name="profile_image"
                                                                            style={{ display: "none" }} // Hide the input
                                                                            onChange={(e) => {
                                                                                handleGroupFileChange(e);
                                                                                e.target.value = ""; // Reset the file input
                                                                            }}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>

                                                                    <label htmlFor="uploadVideo">
                                                                        <img
                                                                            src={filePreview ? filePreview : `${host}${ProfileDataListApiData?.data?.profile_img}`}
                                                                            onClick={() => document.getElementById("uploadVideo").click()}
                                                                            onError={(e) => {
                                                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                            }}
                                                                            className="profile-img w-auto"
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                    </label>



                                                                </div>
                                                            </OverlayTrigger>
                                                        </div>
                                                        <h4 className="text-center mt-3">{ProfileDataListApiData?.data?.name}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Student Name</label>
                                                    <input
                                                        maxLength={20}
                                                        type="text"
                                                        placeholder="Enter your name"
                                                        className="input-form"
                                                        name='name'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.name}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className='text-danger'>{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 row">
                                                    <label htmlFor="">Phone Number</label>


                                                    <div className="col-lg-3 border-end">
                                                        <select className='form-select' name='country_code' onChange={(e) => {
                                                            formik.handleChange(e);

                                                        }}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.country_code} disabled>
                                                            <option value=""> --Select Country--</option>
                                                            {CountryDataListApiData?.map((data) => (
                                                                <option value={data?.phone_code}>{data?.sort_name} ({data?.phone_code})</option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                    <div className="col-lg-9">
                                                        <input
                                                            maxLength={10}
                                                            type="mobile"
                                                            placeholder="Enter your mobile"
                                                            className="input-form"
                                                            name='mobile'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.mobile}
                                                            disabled
                                                        />
                                                    </div>


                                                    {/* <PhoneInput
                                                    limitMaxLength={15}
                                                    id="mobile"
                                                    className="input-form"
                                                    placeholder="Enter your phone number"
                                                    defaultCountry="IN"
                                                    name="mobile"
                                                    value={phone} // Bind tutorformik's value to PhoneInput
                                                    onChange={(value) => { handlePhoneClick(value); }} // Update tutorformik's value
                                                /> */}
                                                    <div className="help-block with-errors">
                                                        {formik.touched.mobile && formik.errors.mobile ? (
                                                            <div className='text-danger'>{formik.errors.mobile}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Email Id</label>
                                                    <input
                                                        maxLength={100}
                                                        type="email"
                                                        placeholder="Enter your email"
                                                        className="input-form"
                                                        name='email'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.email}
                                                        disabled
                                                    />
                                                    {/* <div className="help-block with-errors">
                                                        {formik.touched.email && formik.errors.email ? (
                                                            <div className='text-danger'>{formik.errors.email}</div>
                                                        ) : null}
                                                    </div> */}
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Date of Birth</label>
                                                    <input type="date" className="input-form" name='dob'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.dob}
                                                        max={new Date().toISOString().split("T")[0]}
                                                        // onKeyDown={(e) => e.preventDefault()}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.dob && formik.errors.dob ? (
                                                            <div className='text-danger'>{formik.errors.dob}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Gender</label>
                                                    <select name="gender" id="gender"

                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.gender}>
                                                        <option value=''>-Select-</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                    <div className="help-block with-errors">
                                                        {formik.touched.gender && formik.errors.gender ? (
                                                            <div className='text-danger'>{formik.errors.gender}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <label htmlFor="">Address Line-1</label>
                                                    <input
                                                        maxLength={100}
                                                        type="text"
                                                        placeholder="Enter your address line-1"
                                                        className="input-form"
                                                        name='address_line_1'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.address_line_1}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.address_line_1 && formik.errors.address_line_1 ? (
                                                            <div className='text-danger'>{formik.errors.address_line_1}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Address Line-2</label>
                                                    <input
                                                        maxLength={100}
                                                        type="text"
                                                        placeholder="Enter your address line-2"
                                                        className="input-form"
                                                        name='address_line_2'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.address_line_2}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.address_line_2 && formik.errors.address_line_2 ? (
                                                            <div className='text-danger'>{formik.errors.address_line_2}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Country</label>
                                                    <select name='country_id' onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleCountryChange(e)
                                                    }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.country_id}>
                                                        <option value=""> --Select Country--</option>
                                                        {CountryDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.name}</option>
                                                        ))}

                                                    </select>
                                                    <div className="help-block with-errors">
                                                        {formik.touched.country_id && formik.errors.country_id ? (
                                                            <div className='text-danger'>{formik.errors.country_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">State</label>
                                                    <select name='state_id' onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleStateChange(e)
                                                    }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.state_id}>

                                                        <option selected="" disabled="" value="">
                                                            --Select State--
                                                        </option>
                                                        {StateDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.name}</option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors">
                                                        {formik.touched.state_id && formik.errors.state_id ? (
                                                            <div className='text-danger'>{formik.errors.state_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">City</label>
                                                    <select name="city_id" id="city"

                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.city_id}>
                                                        <option selected="" disabled="" value="">
                                                            --Select City--
                                                        </option>
                                                        {CityDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.name}</option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors">
                                                        {formik.touched.city_id && formik.errors.city_id ? (
                                                            <div className='text-danger'>{formik.errors.city_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label htmlFor="">Zip code</label>
                                                    <input
                                                        type="number"
                                                        placeholder="Enter zip code"
                                                        className="input-form"
                                                        name='zip_code'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.zip_code}
                                                        maxLength={6}
                                                        minLength={4}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.zip_code && formik.errors.zip_code ? (
                                                            <div className='text-danger'>{formik.errors.zip_code}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-lg-12 d-flex justify-content-center">
                                                    <button type="submit" class="login-btn" id="loderButton" disabled={formik.isSubmitting}>

                                                        {formik.isSubmitting ? <HourglassLoader /> : ' Update Profile'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>}
                            </main>

                        </div>
                    </div>
                </div>
            </section>

            {/* Crop Modal */}
            <CropModal
                isOpen={isCropModalOpen}
                imageSrc={imageToCrop}
                onCancel={handleCropCancel}
                onCropComplete={handleCropComplete}
            />

        </div>
    )
}

export default StudentProfileUpdate